'use strict';

angular.module('mandaeApp')
  .filter('endereco', function($filter, $sce) {
    return function(endereco, quebrarEmDuasLinhas, retornarString) {
      if (endereco) {
        try {
          var enderecoFormatado = (endereco.logradouro ? endereco.logradouro.trim() + ', ' : '') +
            (endereco.numero ? endereco.numero.trim() + ', ' : '') +
            (endereco.complemento ? endereco.complemento.trim() + ', ' : '') +
            (quebrarEmDuasLinhas ? '<br />' : '') +
            (endereco.bairro ? endereco.bairro + ', ' : '') +
            (endereco.cep ? $filter('cep')(endereco.cep) + ', ' : '') +
            (endereco.cidade ? endereco.cidade + ' - ' : '') +
            (endereco.uf ? endereco.uf : endereco.estado ? endereco.estado : '')
          return $sce.trustAsHtml(enderecoFormatado);

        } catch (e) {}
      }
    };

  });
